import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCRMBaseUrl, getUserCurrentOrganization } from '../../modules/Auth/AuthReducer'
import { getAccountUrl } from '../../util/crm-url';
import styles from './styles.css';

class AccountNameRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      value, data, crmBaseUrl, organization,
      children, ellipsis,
    } = this.props;

    const isGrouped = this.props.node && this.props.node.group;

    if (!isGrouped && data && data.account_id) {
      const name = children || value || data.name || data.account_id;
      const cls = ellipsis ? styles.ellipsis : null;
      
      if (crmBaseUrl && data && data.account_id) {
        const url = getAccountUrl(organization, data);
        if (url) {
          return (
            <a className={cls} rel="noreferrer" target="_blank" href={url}>{name}</a>
          );
        }
      }
      return <div className={cls}>{name}</div>;
    }

    return value;
  }
}

AccountNameRenderer.propTypes = {
  value: PropTypes.string,
  ellipsis: PropTypes.bool,
  data: PropTypes.shape({
    account_id: PropTypes.string.isRequired,
    name: PropTypes.string,
  }),
  organization: PropTypes.shape({
    type: PropTypes.string,
  }),
  crmBaseUrl: PropTypes.string,
  children: PropTypes.node,
};
AccountNameRenderer.defaultProps = {
  value: null,
  data: null,
  ellipsis: false,
  crmBaseUrl: null,
  children: null,
};

function mapStateToProps(state) {
  return {
    crmBaseUrl: getCRMBaseUrl(state),
    organization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(AccountNameRenderer);
